module.exports = __webpack_public_path__ + "media/images/icon-time-dark-bfc2b2e8eb84a5d0ed191584dab614d9.svg";